import { filterObject } from "@/utils/helpers";
import { useAxios } from "@/utils/hooks/useAxios";
import { useSystem } from "@/utils/hooks/useLocation";
import { useQuery } from "@tanstack/react-query";

export const useOrganizersAndContracts = (params = {}) => {
  const { axiosProtected } = useAxios();
  const { currentSystem } = useSystem();
  const filteredParams = filterObject(params);

  return useQuery({
    queryKey: ["organizers-and-contracts", filteredParams],
    queryFn: () =>
      axiosProtected.get(`${currentSystem}/basic-packages`, { params: filteredParams }),
  });
};
